import Vue from 'vue'
import App from './App.vue'

import Element from 'element-ui'
import './styles/element-variables.scss'
import enLang from 'element-ui/lib/locale/lang/en'

import * as GmapVue from 'gmap-vue'

import '@/styles/index.scss' // global css
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import store from './store'
import router from './router'
import i18n from '@/i18n'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMoment from 'vue-moment'

Vue.use(Element, {
  size: 'small',
  locale: enLang
})

Vue.use(GmapVue, {
  load: {
    key: window._env_.VUE_APP_GOOGLE_KEY,
    libraries: 'drawing,geometry,places'
  },
  installComponents: true
})

Vue.use(VueMoment)
Vue.use(vueNumeralFilterInstaller, { locale: 'es-es' })
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = true

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
